<template>
    <div class="max-w-md mx-auto max-h-[calc(100vh_-_150px)] overflow-auto hide-scrollbar">
        <header class="flex justify-between items-center mb-[24px] border-b pb-4 border-black/30">
            <h2 class="text-[20px] font-[500] flex justify-start items-center">
                Inventory
                <span class="text-sm bg-[#EFEFEF] rounded-[4px] w-6 h-6 flex justify-center items-center ml-2">{{
                    data.length }}</span>
            </h2>
            <button @click="hide" class="text-[16px] font-[400] underline">
                Close
            </button>
        </header>
        <div class="space-y-2">
            <div v-for="(suite, index) in data" :key="index"
                class="flex items-center gap-0 border border-[#E1E1E1] rounded-[10px] overflow-hidden">
                <!-- Suite Image -->
                <div class="w-1/2 flex justify-center items-center h-[142px]">
                    <img v-if="suite.image" class="max-h-[110px] max-w-[100%]" :src="suite.image" />
                </div>
                <!-- Suite Details -->
                <div class="w-1/2 p-4 h-[142px] flex flex-col justify-between bg-[#F7F7F7]">
                    <p class="text-[16px] font-[500]">Suite {{ suite.name }}</p>
                    <p class="text-sm text-black/40">{{ suite.model_name }}</p>
                    <p class="text-[14px] font-[600]">
                        {{ suite.price ? "$" + suite.price?.toLocaleString("en-US") : "-" }}
                    </p>
                    <button :disabled="removing" @click="removeSuite(suite.Mid, suite.Uid)" class="text-[#F64108] flex items-center gap-1">
                        <i class="iconsax text-[14px] text-[#F64108]" icon-name="trash"></i>
                        <span class="text-sm font-[400]">Remove</span>
                    </button>
                </div>
            </div>
            <div class="min-h-[100px] flex justify-center items-center" v-if="data.length == 0 && !removing">
                <p class=" text-gray-600 text-center">
                    Start by adding your favourite suites for submitting a worksheet.
                </p>
            </div>
        </div>
        <!-- Action Buttons -->
        <div class="mt-4 flex justify-between p-1">
            <!-- <button @click="addSuite" class="px-4 py-2 bg-gray-200 text-sm font-medium rounded-md hover:bg-gray-300">
                Add Suite
            </button> -->
            <button @click="addSuite"
                class="text-black cursor-pointer max-md:hidden text-center text-sm whitespace-nowrap border shadow-sm [box-shadow:0px_0px_0px_2px_rgba(0,_0,_0,_0.20)] bg-white flex justify-center items-center h-[42px] w-[121px] rounded-[69px] border-solid border-black max-md:px-5">
                Add Suite
            </button>
            <button @click="$emit('submitWorksheet')"
                :disabled="data.length == 0"
                :class="{'!cursor-not-allowed': data.length == 0}"
                class="text-white bg-black cursor-pointer max-md:hidden text-center text-[16px] font-[500] whitespace-nowrap border flex justify-center items-center h-[42px] w-[240px] rounded-[69px] border-solid max-md:px-5">
                Submit your worksheet
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useWorksheets } from "@/store/worksheet.js";

const props = defineProps({
    models: {
        type: [Object, Array, String],
    },
    counterNumber: {
        type: [Array],
    },
    hide: Function,
});
const data = ref([]);
const worksheet = useWorksheets();

const addSuite = () => {
    console.log('addSuite');
    props.hide()
    worksheet.popupMainWorksheet = true;
    // Add logic to add a new suite to the data array
};

const removing = ref(false)
const removeSuite = (Mid, Uid) => {
    removing.value = true;
    worksheet.toggleWorksheet(Mid, Uid);
    data.value = []
    updateData()
    removing.value = false;
}

const updateData = () => {
    console.log('updateData');
    data.value = []
    props.models.forEach((element) => {
        element.units.forEach((e) => {
            if (
                props.counterNumber.some(
                    (pair) => pair.Mid === element.id && pair.Uid === e.id,
                )
            ) {
                data.value.push({
                    Mid: element.id,
                    Uid: e.id,
                    model_name: element.model_name,
                    name: e.name,
                    image: element.floor_plan.image,
                    type: element.suite_style,
                    price: e.price,
                    area: element.area,
                    bathroom: element.bathroom,
                    exposure: e.exposure,
                });
            }
        });
    });

    data.value.sort((a, b) => a.order - b.order);
};

onMounted(() => {
    updateData()
})

watch(
    () => props.counterNumber,
    () => {
        updateData()
    },
);
</script>
